export default __webpack_public_path__ + "static/media/hirebase-logo.c0be4c2e.svg";